import { render, staticRenderFns } from "./m-txItem.vue?vue&type=template&id=7d0ccd02&scoped=true&"
import script from "./m-txItem.vue?vue&type=script&lang=ts&"
export * from "./m-txItem.vue?vue&type=script&lang=ts&"
import style0 from "./m-txItem.vue?vue&type=style&index=0&id=7d0ccd02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d0ccd02",
  null
  
)

export default component.exports